import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "map-wrapper" };
import { computed, reactive, watch, onBeforeUnmount, onMounted, } from 'vue';
import { i18n } from '@/locales';
import DeliveryChargeAreaControlMap from '@/lib/delivery-charge-area-control';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
const lc = 'views.delivery_charge_area_control.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MapWrapper',
    setup(__props) {
        const getterSubscribeHubCoordinate = computed(() => vuexStore.getters['hubSelector/getterSubscribeHubCoordinate']);
        const deliveryChargeAreaControlMap = reactive(new DeliveryChargeAreaControlMap({
            coordinate: getterSubscribeHubCoordinate.value,
        }));
        const cssClass = computed(() => [
            'tooltip-content',
            'elevation-3',
            'pa-4',
        ]);
        const tooltipPositionX = computed(() => deliveryChargeAreaControlMap.tooltip.position.x);
        const tooltipPositionY = computed(() => deliveryChargeAreaControlMap.tooltip.position.y);
        const getterIsCreateAreaMode = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterIsCreateAreaMode']);
        const getterRegisteredAreaList2 = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterRegisteredAreaList2']);
        const getterCheckedAreaList2 = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterCheckedAreaList2']);
        const getterCheckedAreaKeyList = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterCheckedAreaKeyList']);
        const getterEupMyeonDongBoundaryVisibleKeyList = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterEupMyeonDongBoundaryVisibleKeyList']);
        const getterEupMyeonDongBoundaryCurrentInfoList = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterEupMyeonDongBoundaryCurrentInfoList']);
        const getterDongNameSearchValue = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterDongNameSearchValue']);
        const getterEupMyeonDongBoundaryVisibleList = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterEupMyeonDongBoundaryVisibleList']);
        const position = computed(() => {
            const css = [];
            css.push('position: fixed');
            css.push(`top: ${tooltipPositionY.value - 70}px`);
            css.push(`left: ${tooltipPositionX.value}px`);
            return css.join(';');
        });
        const isTooltipVisible = computed(() => deliveryChargeAreaControlMap.tooltip.isVisible);
        const getterSubscribeOnlyHubId = computed(() => vuexStore.getters['hubSelector/getterSubscribeOnlyHubId']);
        const getterSelectedAreaName = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterSelectedAreaName']);
        const getterCurrentPolygonNeedResetList = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterCurrentPolygonNeedResetList']);
        const setSubscribeHubCoordinate = async (hubId) => {
            const response = await vuexStore.dispatch('hubSelector/setSubscribeHubCoordinate', hubId);
            if (!response.isSuccess) {
                if (response?.reason || response.message) {
                    vuexStore.dispatch(snackbarActionType.showError, response.message);
                }
            }
            deliveryChargeAreaControlMap.setOptions(getterSubscribeHubCoordinate.value);
        };
        const resetCreateAreaPolygon = () => {
            vuexStore.dispatch('deliveryChargeAreaControl/setIsCreateAreaMode', false);
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const handleClickDeleteEupMyeonDongPolygon = () => {
            const isVisible = false;
            const { areaId } = deliveryChargeAreaControlMap.closeButtonInfo;
            deliveryChargeAreaControlMap.setEupMyeonDongPolygonVisible(isVisible, areaId);
        };
        onMounted(() => {
            // 다른 페이지에서 진입이 아닌 새로고침이면 mounted 시 getterSubscribeOnlyHubId = undefined 이므로 이때만 사용자 hubId 사용하기
            deliveryChargeAreaControlMap.init();
            const hubId = getterSubscribeOnlyHubId.value ?? vuexStore.getters['user/hubId'];
            if (!hubId) {
                return;
            }
            setSubscribeHubCoordinate(hubId);
        });
        onBeforeUnmount(() => {
            // resetCreateAreaPolygon();
            deliveryChargeAreaControlMap.destroy();
        });
        // 구역 추가 상태 토글시
        watch(() => getterIsCreateAreaMode.value, (value) => {
            const isCreateAreaMode = true;
            const checkedKeyList = getterCheckedAreaKeyList.value;
            const eupMyeonDongBoundaryVisibleKeyList = getterEupMyeonDongBoundaryVisibleKeyList.value;
            if (value) {
                deliveryChargeAreaControlMap.setPolygonClickableDisabled(value, checkedKeyList);
                deliveryChargeAreaControlMap.setEupMyeonDongBoundaryPolygonClickableDisabled(value, eupMyeonDongBoundaryVisibleKeyList);
                deliveryChargeAreaControlMap.setPolygon(isCreateAreaMode);
            }
            else {
                deliveryChargeAreaControlMap.setPolygonClickableDisabled(value, checkedKeyList);
                deliveryChargeAreaControlMap.setEupMyeonDongBoundaryPolygonClickableDisabled(value, eupMyeonDongBoundaryVisibleKeyList);
                deliveryChargeAreaControlMap.resetPolygon(isCreateAreaMode, 'temp');
            }
        });
        watch(() => getterCurrentPolygonNeedResetList.value, (value) => {
            if (value.length > 0) {
                const isCreateArea = false;
                value.forEach((areaId) => {
                    deliveryChargeAreaControlMap.resetPolygon(isCreateArea, areaId);
                });
                vuexStore.dispatch('deliveryChargeAreaControl/setCurrentPolygonNeedResetList', []);
            }
        });
        // 동이름 검색
        watch(() => getterDongNameSearchValue.value, async (dongName) => {
            if (!dongName) {
                return;
            }
            const alreadyExistList = getterEupMyeonDongBoundaryVisibleList.value
                .filter(({ areaName }) => areaName.includes(dongName));
            if (alreadyExistList.length > 0) {
                const alreadyVisiblePolygonDongNameList = [];
                const successVisibleDongNameList = [];
                alreadyExistList.forEach(({ areaId, areaName }) => {
                    const isVisible = deliveryChargeAreaControlMap.polygonList[areaId].getVisible();
                    if (isVisible) {
                        alreadyVisiblePolygonDongNameList.push(areaName);
                        return;
                    }
                    // 전에 검색한 이력이 있으나 closeButton으로 지도에서 감춘 경우 다시 보여준다
                    deliveryChargeAreaControlMap.setEupMyeonDongPolygonVisible(!isVisible, areaId);
                    successVisibleDongNameList.push(areaName);
                });
                if (alreadyVisiblePolygonDongNameList.length > 0) {
                    const formattedName = alreadyVisiblePolygonDongNameList.join(', ');
                    vuexStore.dispatch(snackbarActionType.showError, `${formattedName} : ${i18n.t(`${lc}already_exist_eup_myeon_dong_boundary`)}`);
                    vuexStore.dispatch('deliveryChargeAreaControl/setSearchValue', {
                        field: 'dongName',
                        value: '',
                    });
                }
                if (successVisibleDongNameList.length > 0) {
                    const formattedName = successVisibleDongNameList.join(', ');
                    vuexStore.dispatch(snackbarActionType.showSuccess, `${formattedName} : ${i18n.t(`${lc}get_eup_myeon_dong_boundary_success`)}`);
                }
                return;
            }
            const { _lat, _lng } = deliveryChargeAreaControlMap.mapInstance.getCenter();
            const response = await vuexStore.dispatch('deliveryChargeAreaControl/setEupMyeonDongBoundaryInfo', {
                isDelete: false,
                payload: {
                    dongName,
                    mapCenterCoordinate: {
                        latitude: _lat,
                        longitude: _lng,
                    },
                },
            });
            if (response.isSuccess) {
                // 현재 지도 중심좌표 근처에 존재하지 않는 동이름인 경우
                if (getterEupMyeonDongBoundaryCurrentInfoList.value.length === 0) {
                    return;
                }
                const successResponseDongNameList = getterEupMyeonDongBoundaryCurrentInfoList.value
                    .map(({ areaId, areaName }) => {
                    // 이미 지도에 있는 폴리곤은 다시 만들지 않는다
                    // 예를 전에 '성'이라고 검색해서 '성수동1가, 성수동2가, 삼성동'을 결과로 받은 경우 삼성동을 삭제하고 다시 '성'으로 검색하면 이미 지도에 그려진 '성수동1가, 성수동2가'가 다시 그려질 수 있으므로 이를 막는다
                    if (deliveryChargeAreaControlMap.polygonList[areaId]) {
                        const isVisible = true;
                        deliveryChargeAreaControlMap.setEupMyeonDongPolygonVisible(isVisible, areaId);
                    }
                    else {
                        deliveryChargeAreaControlMap.setEupMyeonDongPolygon(areaId);
                    }
                    return [
                        areaName,
                    ];
                });
                const formattedName = successResponseDongNameList.join(', ');
                vuexStore.dispatch(snackbarActionType.showSuccess, `${formattedName} ${i18n.t(response.message)}`);
                vuexStore.dispatch('deliveryChargeAreaControl/setEupMyeonDongBoundaryInfo', {
                    isDelete: true,
                });
            }
            else {
                vuexStore.dispatch(snackbarActionType.showError, response.message);
            }
        });
        // 폴리곤 랜더링
        watch(() => getterCheckedAreaList2.value, (value) => {
            // 동경계 제외 다 지움
            deliveryChargeAreaControlMap.destroyAllPolygon(true);
            // coordinate 값 입력
            value.forEach((areaId) => {
                const isCreateAreaMode = false;
                const { coordinateList } = getterRegisteredAreaList2.value
                    .find((item) => item.areaId === areaId);
                if (!coordinateList) {
                    return;
                }
                const registeredPath = coordinateList
                    .map(({ latitude, longitude, }) => ({
                    latitude,
                    longitude,
                }));
                deliveryChargeAreaControlMap.setPolygon(isCreateAreaMode, {
                    areaId,
                    registeredPath,
                });
            });
        });
        // 허브셀렉터변경시
        watch(() => getterSubscribeOnlyHubId.value, async (value) => {
            if (value) {
                vuexStore.dispatch('deliveryChargeAreaControl/setCheckedAreaList2', []);
                resetCreateAreaPolygon();
                deliveryChargeAreaControlMap.init();
                setSubscribeHubCoordinate(value);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" {{ getterRegisteredAreaList2 }} "),
                _cache[0] || (_cache[0] = _createElementVNode("div", { id: "delivery-charge-area-control-map" }, [
                    _createCommentVNode(" 네이버 지도 ")
                ], -1 /* CACHED */)),
                _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(cssClass.value),
                    style: _normalizeStyle(position.value)
                }, _toDisplayString(getterSelectedAreaName.value), 7 /* TEXT, CLASS, STYLE */), [
                    [_vShow, isTooltipVisible.value]
                ])
            ]));
        };
    }
});
